import React from 'react';
import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { CookbookCheckboxWrapper } from 'src/components/CookbookCheckboxWrapper/CookbookCheckboxWrapper';
import { useUniversalLoginDisabled } from './hooks/useUniversalLoginControl';

export interface UniversalLoginControlProps {
  name: string;
  id: string;
}

export function UniversalLoginControl({
  name,
  id,
}: UniversalLoginControlProps): JSX.Element {
  const { control } = useFormContext();
  const { disabled } = useUniversalLoginDisabled();

  return (
    <CookbookCheckboxWrapper
      control={control}
      id={id}
      name={name}
      disabled={disabled}
      label="Enable universal login"
    />
  );
}
